import { COMMUNICATION_NETWORK_GRAPH_CHANNELS, CommunicationNetworkGraphChannelEnum, CommunicationNetworkGraphInspectorStatVariantEnum, CommunicationNetworkGraphNodeKindEnum, CommunicationNetworkGraphScopeEnum } from '@workalizer/shared/types';
export { COMMUNICATION_NETWORK_GRAPH_CHANNELS as COMMUNICATION_CHART_CHANNELS, CommunicationNetworkGraphChannelEnum as CommunicationChartChannelEnum, CommunicationNetworkGraphInspectorStatVariantEnum as CommunicationChartInspectorStatVariantEnum, CommunicationNetworkGraphNodeKindEnum as CommunicationChartNodeKindEnum, CommunicationNetworkGraphScopeEnum as CommunicationChartScopeEnum };
export var isCommunicationChartInspectorStatExtendedVariant = function (variant) {
    return variant === CommunicationNetworkGraphInspectorStatVariantEnum.Extended;
};
export var resolveCommunicationChartInspectorStatVariant = function (showExtended) {
    return showExtended
        ? CommunicationNetworkGraphInspectorStatVariantEnum.Extended
        : CommunicationNetworkGraphInspectorStatVariantEnum.Compact;
};
export var isCommunicationChartOrgScope = function (scope) {
    return scope === CommunicationNetworkGraphScopeEnum.Org;
};
export var isCommunicationChartTeamScope = function (scope) {
    return scope === CommunicationNetworkGraphScopeEnum.Team;
};
export var isCommunicationChartEmployeeScope = function (scope) {
    return scope === CommunicationNetworkGraphScopeEnum.Employee;
};
export var isCommunicationChartEmailChannel = function (channel) {
    return channel === CommunicationNetworkGraphChannelEnum.Email;
};
export var isCommunicationChartChatChannel = function (channel) {
    return channel === CommunicationNetworkGraphChannelEnum.Chat;
};
export var isCommunicationChartDirectedChannel = function (channel) {
    return isCommunicationChartEmailChannel(channel) ||
        isCommunicationChartChatChannel(channel);
};
export var isCommunicationChartMeetChannel = function (channel) {
    return channel === CommunicationNetworkGraphChannelEnum.Meet;
};
